// src/components/Header/HeaderSignedIn.js
import React from 'react';
import { Link } from 'react-router-dom';
import UserAvatar from '../UI/UserAvatar';

const HeaderSignedIn = ({ onNavMenuTriggerClick, menuOpen, userAvatar, userName }) => {
  return (
    <header>
      <div className="container-fluid">
        <div className="row middle-xs">
          <div className="col-xs-6 justify-left">
            <Link to="/">
              <img className="middle" src="/images/Logo.svg" alt="Logo" />
            </Link>
          </div>
          <div className="col-xs-6 justify-right">
            <div className="nav-menu-trigger" onClick={onNavMenuTriggerClick}>
              <UserAvatar 
                avatarUrl={userAvatar}
                userName={userName}
                // Add the 'hidden' class when menuOpen is true:
                className={menuOpen ? 'hidden' : ''}
              />
              <img 
                className={`menu-close ${menuOpen ? 'visible' : ''}`} 
                src="/images/i_menu_close.svg" 
                alt="Close Menu" 
              />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default HeaderSignedIn;
